import AccountInfoHolder from "../accountInforHolder/accountInfoHolder";
import styles from "./asset/adminHeaderBar.module.scss";

const AdminHeaderBar = () => {
    return (
        <header className={styles.headerBar}>
            <div className={styles.headerIntro}>
                <div>
                    <span className={styles.eyebrow}>Prepal internal</span>
                    <h1>Admin portal</h1>
                    <p>Version 1.0 • Internal preview state</p>
                </div>

                <div className={styles.metaGroup}>
                    <span className={styles.metaPill}>Live state</span>
                    <span className={styles.metaPillSecondary}>Ops build</span>
                </div>
            </div>

            <div className={styles.accountBlock}>
                <AccountInfoHolder />
            </div>
        </header>
    );
};

export default AdminHeaderBar;
